export default __webpack_public_path__ + "static/media/verify-me.0f118ff8.webp";